ux-table-data-column-checkbox {
  display: none;
}
